// Main entry point for Session management/info
import { Map } from 'immutable';
import UserReducer from './user';
import { combineImmutableReducers } from '../../util';

const DEFAULT_SESSION = new Map();

const REDUCERS = {
  currentUser: UserReducer
};

// As this is not a leaf-node, the reducer follows the very simple pattern
// of combining child reducers, which are each responsible for one child attribute.
const SessionReducer = combineImmutableReducers(REDUCERS, DEFAULT_SESSION);

export default SessionReducer;

// Selectors
// Note: these functions operate on state at the level of the SessionReducer, not the RootReducer.
export const currentUser = (state) => state.get("currentUser");



// WEBPACK FOOTER //
// ./src/session/reducers/index.js